/**
 * 支給デザインの `product-card` 内 `product-cat`（小カテゴリの表示名）。
 *
 * この値は `/api/v1/front/productContents/{category}` の応答に含まれていないため、
 * カテゴリIDから引く。現在はタブのラベル（サプリメント／食品／スキンケア／パーソナルケア）と
 * 同じ文字列だが、`product-cat` は小カテゴリの表示名なので別の定数のままにする。
 *
 * 支給デザインはスキンケアの4商品だけ剤形（化粧水／美容乳液／クリーム／セット）を括弧で添えているが、
 * 実装では添えず「スキンケア」で統一する（決定#32）。
 */

/** カテゴリID → `product-cat` の表示名。ID は `ProductContentConst` の `CATEGORY_JAPANESE_NAME` と同じ採番 */
export const PRODUCT_CARD_CATEGORY_NAME: Readonly<Record<number, string>> = {
  1: 'サプリメント',
  2: 'スキンケア',
  3: 'パーソナルケア',
  4: '食品',
} as const;

/** `product-name` の下に「機能性表示食品」を出す商品コード。対象は現状 210 のみだが増えうるので集合で持つ */
export const PRODUCT_CARD_FUNCTIONAL_FOOD_CODES: readonly string[] = ['210'] as const;

/** 上記商品の `product-name` 直下に出す注記の文言 */
export const PRODUCT_CARD_FUNCTIONAL_FOOD_LABEL = '機能性表示食品' as const;
